import { useGetTermAndCondition } from 'api-hooks/term-and-condition/query';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';

import SkeletonTermAndCondition from './skeleton-index';
import TermAndCondition from './term-and-condition';

export default function TermCondition() {
  const { data, isLoading, isFetching } = useGetTermAndCondition();

  return (
    <>
      <FetchWrapperComponent
        isLoading={isLoading || isFetching}
        loadingComponent={<SkeletonTermAndCondition />}
        component={data?.data && <TermAndCondition data={data.data} />}
      />
    </>
  );
}
